export default __webpack_public_path__ + "static/revopsherosvg-06da3daa70b075611583d5107c1657dc.svg";